/* B2B Forms App Style Injector */
/* This script injects custom styles into the Shopify Forms app Shadow DOM using adoptedStyleSheets */

document.addEventListener('DOMContentLoaded', () => {
  // Only run this script if we're on a page with Shopify Forms app
  if (!document.querySelector('[id*="shopify-block"][id*="forms_inline"]')) {
    console.log('No Shopify Forms app detected on this page, skipping b2b-forms-app-override.js');
    return;
  }
  
  // Target the form container on the B2B wholesale page
  const formContainer = document.querySelector('#shopify-block-AdnFWYzkrZWVTU0FML__forms_inline_nxDEgN');

  const observer = new MutationObserver((mutationsList, observer) => {
    const form = document.querySelector('form-embed');

    if (form && form.shadowRoot) {
      observer.disconnect();
      const shadow = form.shadowRoot;

      const sheet = new CSSStyleSheet();
      
      // Hide the form initially to prevent flash
      sheet.insertRule(`
        * {
          visibility: hidden;
        }
      `, 0);
      
      // Form container styling - only style the inner form, not outer containers
      sheet.insertRule(`
        form {
          background: white !important;
          border-radius: 12px !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.8) !important;
          padding: 48px !important;
          max-width: 800px !important;
          margin: 0 auto !important;
          width: 100% !important;
          box-sizing: border-box !important;
        }
      `);
      
      // Override the col-size CSS variable
      sheet.insertRule(`
        ._formContainer_1q1d2_30,
        [class*="_formContainer"] {
          --col-size: 100% !important;
        }
      `);
      
      // Input styling - clean minimal style
      sheet.insertRule(`
        input[type="text"],
        input[type="email"],
        input[type="tel"],
        input[type="url"],
        input[type="number"],
        textarea,
        select {
          width: 100% !important;
          padding: 12px 0 !important;
          border: none !important;
          border-bottom: 1px solid #E5E5E5 !important;
          border-radius: 0 !important;
          font-size: 16px !important;
          color: #333 !important;
          background-color: transparent !important;
          transition: border-color 0.3s !important;
          box-shadow: none !important;
          -webkit-appearance: none !important;
          -moz-appearance: none !important;
          appearance: none !important;
          margin-bottom: 8px !important;
          font-family: 'Gotham', 'Helvetica Neue', Arial, sans-serif !important;
        }
      `);
      
      // Focus state for inputs
      sheet.insertRule(`
        input:focus,
        textarea:focus,
        select:focus {
          outline: none !important;
          border-bottom-color: #FF8C42 !important;
          box-shadow: none !important;
        }
      `);
      
      // Label styling
      sheet.insertRule(`
        label {
          font-size: 14px !important;
          font-weight: 600 !important;
          color: #333 !important;
          margin-bottom: 8px !important;
          display: block !important;
          font-family: 'Gotham', 'Helvetica Neue', Arial, sans-serif !important;
        }
      `);
      
      // Field container spacing
      sheet.insertRule(`
        ._formFieldContainer_1ydxd_5,
        .field-container,
        [data-testid*="field-container"] {
          margin-bottom: 24px !important;
        }
      `);
      
      // Submit button - only target actual submit buttons
      sheet.insertRule(`
        button[type="submit"],
        button._formSubmitButton_cit2d_96,
        [data-testid="btn-form-submit"] {
          background-color: #FF8C42 !important;
          color: white !important;
          padding: 18px 48px !important;
          border: none !important;
          border-radius: 50px !important;
          font-size: 16px !important;
          font-weight: 700 !important;
          text-transform: uppercase !important;
          letter-spacing: 1px !important;
          cursor: pointer !important;
          transition: background-color 0.3s !important;
          margin: 32px auto 0 !important;
          display: block !important;
          width: auto !important;
          min-width: 200px !important;
          font-family: 'Gotham', 'Helvetica Neue', Arial, sans-serif !important;
          text-align: center !important;
          text-align: -webkit-center !important;
        }
      `);
      
      // Button hover state
      sheet.insertRule(`
        button[type="submit"]:hover,
        button._formSubmitButton_cit2d_96:hover,
        [data-testid="btn-form-submit"]:hover {
          background-color: #E67A3A !important;
        }
      `);
      
      // Hide dropdown/select toggle buttons that appear as orange buttons
      sheet.insertRule(`
        button[aria-expanded],
        button[aria-haspopup="listbox"],
        button:not([type="submit"]):not(._formSubmitButton_cit2d_96) {
          background-color: transparent !important;
          color: #333 !important;
          border: 1px solid #E5E5E5 !important;
          border-radius: 4px !important;
          padding: 8px 12px !important;
          text-transform: none !important;
          letter-spacing: normal !important;
          font-weight: normal !important;
          font-size: 16px !important;
          width: 100% !important;
          text-align: left !important;
          margin: 0 !important;
        }
      `);
      
      // Remove backgrounds from containers
      sheet.insertRule(`
        ._appEmbedRoot_1d2l7_9,
        ._appEmbed_3eyaa_1,
        ._container_3eyaa_70,
        ._inline_1q1d2_47,
        section,
        [data-testid="app-embed-root"] {
          background-color: transparent !important;
        }
      `);
      
      // Form grid layout for side-by-side fields
      sheet.insertRule(`
        form,
        ._formFieldset_cit2d_82 {
          display: flex !important;
          flex-direction: column !important;
          gap: 0 !important;
        }
      `);
      
      // Add border around fieldset
      sheet.insertRule(`
        ._formFieldset_cit2d_82 {
          background: white !important;
          border: 1px solid #E5E5E5 !important;
          border-radius: 12px !important;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
          padding: 32px !important;
          margin: 24px 0 !important;
        }
      `);
      
      // Style form header when inside fieldset
      sheet.insertRule(`
        ._formFieldset_cit2d_82 ._formHeader_cit2d_24 {
          margin-bottom: 24px !important;
          padding-bottom: 24px !important;
          border-bottom: none !important;
        }
      `);
      
      // Style for row containers (First name / Last name, City / ZIP)
      sheet.insertRule(`
        ._formFieldRow_1ydxd_47,
        [data-testid*="field-row"] {
          display: grid !important;
          grid-template-columns: 1fr 1fr !important;
          gap: 24px !important;
          margin-bottom: 24px !important;
        }
      `);
      
      // Make vertical layout wrap
      sheet.insertRule(`
        ._verticalLayout_1hja3_8 {
          display: flex !important;
          flex-flow: wrap !important;
          justify-content: space-between !important;
        }
      `);
      
      // Increase dropdown container height
      sheet.insertRule(`
        ._dropdownContainer_udw4q_63,
        ._showDownwards_udw4q_72,
        [class*="_dropdownContainer"] {
          max-height: 350px !important;
          height: auto !important;
          min-height: 200px !important;
        }
      `);
      
      // Ensure the option list can scroll properly
      sheet.insertRule(`
        ._optionList_udw4q_86,
        [class*="_optionList"] {
          max-height: 330px !important;
          overflow-y: auto !important;
        }
      `);
      
      // Ensure dropdowns look like inputs
      sheet.insertRule(`
        select,
        [role="combobox"] {
          width: 100% !important;
          padding: 12px 0 !important;
          border: none !important;
          border-bottom: 1px solid #E5E5E5 !important;
          background-color: transparent !important;
          font-size: 16px !important;
          color: #333 !important;
        }
      `);
      
      // Watch for dynamically created dropdown containers
      const dropdownObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Check if this is a dropdown container
              if (node.classList && (
                node.classList.contains('_dropdownContainer_udw4q_63') ||
                node.classList.contains('_showDownwards_udw4q_72') ||
                Array.from(node.classList).some(cls => cls.includes('_dropdownContainer'))
              )) {
                // Apply styles directly to the element
                node.style.removeProperty('max-height');
                node.style.setProperty('max-height', '350px', 'important');
                node.style.setProperty('height', 'auto', 'important');
                node.style.setProperty('min-height', '200px', 'important');
              }
              
              // Also check children for dropdown containers
              const dropdowns = node.querySelectorAll('[class*="_dropdownContainer"]');
              dropdowns.forEach(dropdown => {
                dropdown.style.removeProperty('max-height');
                dropdown.style.setProperty('max-height', '350px', 'important');
                dropdown.style.setProperty('height', 'auto', 'important');
                dropdown.style.setProperty('min-height', '200px', 'important');
              });
              
              // Check for option lists inside the node
              const optionLists = node.querySelectorAll('._optionList_udw4q_86, [class*="_optionList"]');
              optionLists.forEach(list => {
                list.style.setProperty('max-height', '330px', 'important');
                list.style.setProperty('overflow-y', 'auto', 'important');
              });
            }
          });
        });
      });
      
      // Start observing the shadow DOM for changes
      dropdownObserver.observe(shadow, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style']
      });
      
      // Also add click event listeners to dropdown buttons
      shadow.addEventListener('click', (event) => {
        // Check if clicked element is a dropdown button
        const target = event.target;
        if (target && (target.hasAttribute('aria-expanded') || target.hasAttribute('aria-haspopup'))) {
          // Wait a bit for the dropdown to render
          setTimeout(() => {
            const dropdowns = shadow.querySelectorAll('._dropdownContainer_udw4q_63, ._showDownwards_udw4q_72, [class*="_dropdownContainer"]');
            dropdowns.forEach(dropdown => {
              dropdown.style.removeProperty('max-height');
              dropdown.style.setProperty('max-height', '350px', 'important');
              dropdown.style.setProperty('height', 'auto', 'important');
              dropdown.style.setProperty('min-height', '200px', 'important');
            });
            
            // Also handle option lists
            const optionLists = shadow.querySelectorAll('._optionList_udw4q_86, [class*="_optionList"]');
            optionLists.forEach(list => {
              list.style.setProperty('max-height', '480px', 'important');
              list.style.setProperty('overflow-y', 'auto', 'important');
            });
          }, 10);
        }
      }, true);
      
      // Add padding to the overall form area
      sheet.insertRule(`
        #app-embed,
        [data-testid="app-embed"] {
          padding: 0 !important;
          background: transparent !important;
        }
      `);
      
      // Style the form title
      sheet.insertRule(`
        h1, h2, h3,
        ._formHeading_cit2d_68,
        ._textHeading_2aowh_35 {
          font-family: 'Recoleta', Georgia, serif !important;
          font-size: 42px !important;
          font-weight: 400 !important;
          color: #59432D !important;
          margin: 0 0 16px 0 !important;
          line-height: 1.2 !important;
          text-align: center !important;
        }
      `);
      
      // Specific styling for the banner heading
      sheet.insertRule(`
        h2._formBannerHeading_z5ku3_9 {
          justify-content: center !important;
          justify-self: center !important;
          display: flex !important;
          text-align: center !important;
          width: 100% !important;
        }
      `);
      
      // Style the form description
      sheet.insertRule(`
        p,
        ._formDescription_cit2d_72,
        ._textParagraph_1sffu_41 {
          font-size: 16px !important;
          color: #666 !important;
          margin: 0 0 32px 0 !important;
          text-align: center !important;
          font-family: 'Gotham', 'Helvetica Neue', Arial, sans-serif !important;
        }
      `);
      
      // Style checkbox wrapper to center it
      sheet.insertRule(`
        ._checkboxWrapper_1hja3_33 {
          justify-self: center !important;
        }
      `);
      
      // Style checkbox field
      sheet.insertRule(`
        ._checkboxField_1hja3_3 {
          max-width: 100px !important;
          text-align: center !important;
        }
      `);
      
      // Add transition for all labels
      sheet.insertRule(`
        label {
          transition: transform 0.2s ease-out !important;
        }
      `);
      
      // Adjust label transform for ALL labels when their associated input is focused or has value
      sheet.insertRule(`
        input:focus ~ label,
        input:not(:placeholder-shown) ~ label,
        input:valid ~ label,
        input[value]:not([value=""]) ~ label,
        textarea:focus ~ label,
        textarea:not(:placeholder-shown) ~ label,
        textarea:valid ~ label,
        textarea[value]:not([value=""]) ~ label,
        select:focus ~ label,
        select:valid ~ label,
        select[value]:not([value=""]) ~ label {
          --input-label-Y-transform: calc(var(--input-label-top) * -1.2) !important;
          --input-label-transform: translateY(var(--input-label-Y-transform)) scale(0.85) !important;
          transform: var(--input-label-transform) !important;
        }
      `);
      
      // Add padding to multiFieldLine
      sheet.insertRule(`
        div._multiFieldLine_exnrn_1 {
          padding-top: 24px !important;
        }
      `);
      
      // Set max-width for inline form container
      sheet.insertRule(`
        ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
          max-width: 800px !important;
        }
      `);

      // Set max-width for inline form container
      sheet.insertRule(`
        ._inline_1q1d2_47 {
          justify-items: center !important;
        }
      `);
      
      // Add padding to grid item content
      sheet.insertRule(`
        div._gridItem_1q1d2_172._gridItemContent_1q1d2_257 {
          padding-right: 12px !important;
          padding-left: 12px !important;
        }
      `);
      
      // Style for EIN error messages
      sheet.insertRule(`
        .ein-error-message {
          color: #e02229 !important;
          font-size: 12px !important;
          margin-top: 4px !important;
          font-family: 'Gotham', 'Helvetica Neue', Arial, sans-serif !important;
        }
      `);
      
      // Style for form submission error messages
      sheet.insertRule(`
        .form-error-container {
          color: #e02229 !important;
          font-size: 14px !important;
          margin-top: 16px !important;
          text-align: center !important;
          font-family: 'Gotham', 'Helvetica Neue', Arial, sans-serif !important;
          background-color: #fef2f2 !important;
          border: 1px solid #fecaca !important;
          border-radius: 8px !important;
          padding: 12px 16px !important;
        }
      `);
      
      // Prevent text wrapping for shipping_address_zip label
      sheet.insertRule(`
        label[for="label-shipping_address_zip"],
        label[for*="shipping_address_zip"],
        label:has(+ input[name*="shipping_address_zip"]) {
          white-space: nowrap !important;
          overflow: visible !important;
        }
      `);
      
      // Show everything after styles are applied
      sheet.insertRule(`
        * {
          visibility: visible !important;
        }
      `, sheet.cssRules.length);

      shadow.adoptedStyleSheets.push(sheet);
      
      // Move form header inside fieldset
      setTimeout(() => {
        const formHeader = shadow.querySelector('._formHeader_cit2d_24');
        const formFieldset = shadow.querySelector('._formFieldset_cit2d_82');
        
        if (formHeader && formFieldset) {
          // Clone the header to preserve event listeners
          const headerClone = formHeader.cloneNode(true);
          
          // Insert at the beginning of the fieldset
          formFieldset.insertBefore(headerClone, formFieldset.firstChild);
          
          // Hide the original header
          formHeader.style.display = 'none';
          
          console.log('Form header moved inside fieldset');
        }
      }, 100);
      
      // Add EIN number formatting - only for Shopify Forms inside shadow DOM
      setTimeout(() => {
        // Make sure we're working with the Shopify Forms shadow DOM
        if (!shadow || !form) {
          console.log('Not in Shopify Forms shadow DOM, skipping EIN formatting');
          return;
        }
        
        // Find the EIN number input field - check multiple possible selectors
        const einInputs = shadow.querySelectorAll('input[id*="ein_number"], input[name*="ein_number"], input#custom\\#ein_number');
        
        einInputs.forEach(einInput => {
          // Check if this is actually the EIN field by looking at the label or placeholder
          const label = einInput.parentElement?.querySelector('label');
          const isEINField = (einInput.id?.toLowerCase().includes('ein_number') || 
                           einInput.name?.toLowerCase().includes('ein_number') || 
                           label?.textContent?.toLowerCase().includes('ein number')) &&
                           einInput.type !== 'checkbox' && 
                           einInput.type !== 'radio';
          
          if (einInput && isEINField && !einInput.hasAttribute('data-ein-formatted')) {
            // Mark as formatted to avoid duplicate listeners
            einInput.setAttribute('data-ein-formatted', 'true');
            
            // Add a unique identifier to ensure we only format this specific input
            const einId = 'ein-' + Math.random().toString(36).substring(7);
            einInput.setAttribute('data-ein-id', einId);
            
            // If it's a number input, change it to text to allow dashes
            if (einInput.type === 'number') {
              einInput.type = 'text';
            }
            
            // Add pattern attribute for mobile keyboards
            einInput.pattern = '[0-9]{2}-[0-9]{7}';
            
            // Add placeholder if not present
            if (!einInput.placeholder) {
              einInput.placeholder = 'XX-XXXXXXX';
            }
            
            // Set max length to prevent excessive input
            einInput.maxLength = 10; // 9 digits + 1 dash
            
            // Function to format EIN
            const formatEIN = (value) => {
              // Ensure value is a string
              if (typeof value !== 'string') {
                value = String(value || '');
              }
              
              // Remove all non-digits
              let digits = value.replace(/\D/g, '');
              
              // Strictly limit to 9 digits total - important to prevent overflow
              digits = digits.substring(0, 9);
              
              // Format as XX-XXXXXXX
              if (digits.length >= 3) {
                return digits.substring(0, 2) + '-' + digits.substring(2);
              } else {
                return digits;
              }
            };
            
            // Format EIN on input - immediate formatting for better UX
            let isFormattingEIN = false;
            einInput.addEventListener('input', (e) => {
              // Only process if this event is for the EIN input
              if (e.target !== einInput) return;
              
              // Double-check this is the EIN field
              const targetId = e.target.getAttribute('data-ein-id');
              if (targetId !== einId) return;
              
              // Prevent recursive formatting
              if (isFormattingEIN) return;
              
              const currentValue = e.target.value;
              const formattedValue = formatEIN(currentValue);
              
              // Only update if the value actually changed
              if (currentValue !== formattedValue) {
                isFormattingEIN = true;
                
                // Save cursor position
                const cursorPos = e.target.selectionStart;
                const wasAtDash = currentValue[cursorPos - 1] === '-';
                
                e.target.value = formattedValue;
                
                // Restore cursor position intelligently
                let newCursorPos = cursorPos;
                
                // If we just typed the 2nd digit, move cursor after the dash
                if (cursorPos === 2 && formattedValue.length > 2 && formattedValue[2] === '-') {
                  newCursorPos = 3;
                }
                // If we were at a dash, stay after it
                else if (wasAtDash && formattedValue[cursorPos] === '-') {
                  newCursorPos = cursorPos + 1;
                }
                // If a dash was inserted before cursor, adjust position
                else if (formattedValue[cursorPos - 1] === '-' && currentValue[cursorPos - 1] !== '-') {
                  newCursorPos = cursorPos + 1;
                }
                
                e.target.setSelectionRange(newCursorPos, newCursorPos);
                
                // Reset flag after a short delay
                setTimeout(() => {
                  isFormattingEIN = false;
                }, 10);
              }
            }, false); // Don't use capture phase
            
            // Format EIN on paste
            einInput.addEventListener('paste', (e) => {
              // Only process if this event is for the EIN input
              if (e.target !== einInput) return;
              
              e.preventDefault(); // Keep this to handle paste formatting
              
              const pastedText = (e.clipboardData || window.clipboardData).getData('text');
              e.target.value = formatEIN(pastedText);
              
              // Trigger input event for consistency
              const inputEvent = new Event('input', { bubbles: true });
              e.target.dispatchEvent(inputEvent);
            });
            
            // Prevent non-numeric input (but allow dash for better UX)
            einInput.addEventListener('keypress', (e) => {
              // Only process if this event is for the EIN input
              if (e.target !== einInput) return;
              
              const char = String.fromCharCode(e.which);
              
              // Allow numbers, backspace, delete, arrow keys, tab
              const allowedKeys = [8, 9, 37, 38, 39, 40, 46];
              
              if (!/[0-9]/.test(char) && !allowedKeys.includes(e.which)) {
                e.preventDefault(); // Only prevent the invalid character
              }
            });
            
            // Validate on blur
            einInput.addEventListener('blur', (e) => {
              const value = e.target.value;
              const isValid = /^\d{2}-\d{7}$/.test(value);
              
              if (value && !isValid) {
                // Add error styling
                einInput.style.borderBottomColor = '#e02229';
                
                // Add error message if not already present
                let errorMsg = einInput.parentElement.querySelector('.ein-error-message');
                if (!errorMsg) {
                  errorMsg = document.createElement('div');
                  errorMsg.className = 'ein-error-message';
                  errorMsg.style.cssText = 'color: #e02229; font-size: 12px; margin-top: 4px;';
                  errorMsg.textContent = 'Please enter a valid EIN in format XX-XXXXXXX';
                  einInput.parentElement.appendChild(errorMsg);
                }
              } else {
                // Remove error styling
                einInput.style.borderBottomColor = '';
                
                // Remove error message
                const errorMsg = einInput.parentElement.querySelector('.ein-error-message');
                if (errorMsg) {
                  errorMsg.remove();
                }
              }
            });
            
            console.log('EIN number formatting applied');
          }
        });
        
        // Watch for dynamically added EIN fields
        const einObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === 1) { // Element node
                // Check if this is an input field
                const inputs = node.tagName === 'INPUT' ? [node] : node.querySelectorAll?.('input');
                if (inputs) {
                  inputs.forEach(input => {
                    if ((input.id?.toLowerCase().includes('ein_number') || 
                         input.name?.toLowerCase().includes('ein_number')) && 
                        input.type !== 'checkbox' && 
                        input.type !== 'radio' &&
                        !input.hasAttribute('data-ein-formatted')) {
                      // Mark as formatted to avoid duplicate listeners
                      input.setAttribute('data-ein-formatted', 'true');
                      
                      // Add a unique identifier to ensure we only format this specific input
                      const einId = 'ein-' + Math.random().toString(36).substring(7);
                      input.setAttribute('data-ein-id', einId);
                      
                      // If it's a number input, change it to text to allow dashes
                      if (input.type === 'number') {
                        input.type = 'text';
                      }
                      
                      // Add pattern attribute
                      input.pattern = '[0-9]{2}-[0-9]{7}';
                      
                      // Apply the same formatting logic
                      if (!input.placeholder) {
                        input.placeholder = 'XX-XXXXXXX';
                      }
                      
                      // Set max length to prevent excessive input
                      input.maxLength = 10; // 9 digits + 1 dash
                      
                      const formatEIN = (value) => {
                        // Ensure value is a string
                        if (typeof value !== 'string') {
                          value = String(value || '');
                        }
                        
                        // Remove all non-digits
                        let digits = value.replace(/\D/g, '');
                        
                        // Strictly limit to 9 digits total - important to prevent overflow
                        digits = digits.substring(0, 9);
                        
                        // Format as XX-XXXXXXX
                        if (digits.length >= 3) {
                          return digits.substring(0, 2) + '-' + digits.substring(2);
                        } else {
                          return digits;
                        }
                      };
                      
                      let isDynamicFormattingEIN = false;
                      input.addEventListener('input', (e) => {
                        // Only process if this event is for this specific input
                        if (e.target !== input) return;
                        
                        // Double-check this is the EIN field
                        const targetId = e.target.getAttribute('data-ein-id');
                        if (targetId !== einId) return;
                        
                        // Prevent recursive formatting
                        if (isDynamicFormattingEIN) return;
                        
                        const currentValue = e.target.value;
                        const formattedValue = formatEIN(currentValue);
                        
                        // Only update if the value actually changed
                        if (currentValue !== formattedValue) {
                          isDynamicFormattingEIN = true;
                          
                          const cursorPos = e.target.selectionStart;
                          const wasAtDash = currentValue[cursorPos - 1] === '-';
                          
                          e.target.value = formattedValue;
                          
                          let newCursorPos = cursorPos;
                          
                          // If we just typed the 2nd digit, move cursor after the dash
                          if (cursorPos === 2 && formattedValue.length > 2 && formattedValue[2] === '-') {
                            newCursorPos = 3;
                          }
                          // If we were at a dash, stay after it
                          else if (wasAtDash && formattedValue[cursorPos] === '-') {
                            newCursorPos = cursorPos + 1;
                          }
                          // If a dash was inserted before cursor, adjust position
                          else if (formattedValue[cursorPos - 1] === '-' && currentValue[cursorPos - 1] !== '-') {
                            newCursorPos = cursorPos + 1;
                          }
                          
                          e.target.setSelectionRange(newCursorPos, newCursorPos);
                          
                          setTimeout(() => {
                            isDynamicFormattingEIN = false;
                          }, 10);
                        }
                      }, false); // Don't use capture phase
                      
                      input.addEventListener('paste', (e) => {
                        // Only process if this event is for this specific input
                        if (e.target !== input) return;
                        
                        e.preventDefault();
                        
                        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                        e.target.value = formatEIN(pastedText);
                        
                        // Trigger input event
                        const inputEvent = new Event('input', { bubbles: true });
                        e.target.dispatchEvent(inputEvent);
                      });
                      
                      input.addEventListener('keypress', (e) => {
                        // Only process if this event is for this specific input
                        if (e.target !== input) return;
                        
                        const char = String.fromCharCode(e.which);
                        const allowedKeys = [8, 9, 37, 38, 39, 40, 46];
                        if (!/[0-9]/.test(char) && !allowedKeys.includes(e.which)) {
                          e.preventDefault();
                        }
                      });
                      
                      console.log('EIN formatting applied to dynamically added field');
                    }
                  });
                }
              }
            });
          });
        });
        
        // Start observing for new input fields
        einObserver.observe(shadow, { childList: true, subtree: true });
      }, 200);
      
      // Add error message handling for form submission
      const addFormErrorHandling = () => {
        const form = shadow.querySelector('form');
        const submitButton = shadow.querySelector('button[type="submit"], button._formSubmitButton_cit2d_96, [data-testid="btn-form-submit"]');
        
        if (form && submitButton) {
          // Create error message container
          let errorContainer = shadow.querySelector('.form-error-container');
          if (!errorContainer) {
            errorContainer = document.createElement('div');
            errorContainer.className = 'form-error-container';
            errorContainer.style.cssText = `
              color: #e02229;
              font-size: 14px;
              margin-top: 16px;
              text-align: center;
              font-family: 'Gotham', 'Helvetica Neue', Arial, sans-serif;
              background-color: #fef2f2;
              border: 1px solid #fecaca;
              border-radius: 8px;
              padding: 12px 16px;
              display: none;
            `;
            // Try to insert it right after the submit button
            if (submitButton.parentElement) {
              submitButton.parentElement.insertBefore(errorContainer, submitButton.nextSibling);
            } else {
              // If submit button has no parent, append to form
              form.appendChild(errorContainer);
            }
          }
          
          // Storefront API configuration
          // NOTE: You need to replace this with your actual Storefront API token
          const STOREFRONT_API_TOKEN = 'YOUR_STOREFRONT_API_TOKEN_HERE';
          const STOREFRONT_API_VERSION = '2024-01';
          const SHOP_DOMAIN = 'foursigmatic.myshopify.com';
          
          // Function to check if customer exists
          // Note: Storefront API has limitations for customer lookups
          // If this doesn't work, you'll need to use the server-side approach
          const checkCustomerExists = async (email) => {
            // First try server-side endpoint if available
            const serverEndpoint = '/apps/customer-check';
            
            try {
              // Try server-side endpoint first (more reliable)
              const serverResponse = await fetch(serverEndpoint, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({ email })
              });
              
              if (serverResponse.ok) {
                const data = await serverResponse.json();
                return data.exists;
              }
            } catch (error) {
              console.log('Server endpoint not available, trying Storefront API');
            }
            
            // Fallback to Storefront API (limited functionality)
            try {
              const query = `
                query customerByEmail($email: String!) {
                  customer(email: $email) {
                    id
                    email
                  }
                }
              `;
              
              const response = await fetch(`https://${SHOP_DOMAIN}/api/${STOREFRONT_API_VERSION}/graphql.json`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Shopify-Storefront-Access-Token': STOREFRONT_API_TOKEN
                },
                body: JSON.stringify({
                  query: query,
                  variables: { email: email }
                })
              });
              
              const data = await response.json();
              console.log('Storefront API response:', data);
              
              // Note: This will likely return null due to Storefront API restrictions
              // Customer queries typically require authentication
              return !!data.data?.customer;
            } catch (error) {
              console.error('Error checking customer:', error);
              return false;
            }
          };
          
          // Add email validation on blur
          const addEmailValidation = () => {
            const emailInput = shadow.querySelector('input[type="email"], input#email, input[name="email"], input[inputmode="email"]');
            
            if (emailInput && !emailInput.hasAttribute('data-email-validation')) {
              emailInput.setAttribute('data-email-validation', 'true');
              
              // Add real-time email validation
              emailInput.addEventListener('blur', async (e) => {
                const email = e.target.value;
                
                if (!email) return;
                
                // Remove any existing error
                let existingError = emailInput.parentElement.querySelector('.email-error-message');
                if (existingError) {
                  existingError.remove();
                }
                emailInput.style.borderBottomColor = '';
                
                // Basic email format validation
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                if (!emailRegex.test(email)) {
                  // Show format error
                  let errorMsg = document.createElement('div');
                  errorMsg.className = 'email-error-message';
                  errorMsg.style.cssText = 'color: #e02229; font-size: 12px; margin-top: 4px; font-family: Gotham, sans-serif;';
                  errorMsg.textContent = 'Please enter a valid email address';
                  emailInput.parentElement.appendChild(errorMsg);
                  emailInput.style.borderBottomColor = '#e02229';
                  return;
                }
                
                // Check if customer exists with this email
                if (STOREFRONT_API_TOKEN !== 'YOUR_STOREFRONT_API_TOKEN_HERE') {
                  const customerExists = await checkCustomerExists(email);
                  
                  if (customerExists) {
                    let errorMsg = document.createElement('div');
                    errorMsg.className = 'email-error-message';
                    errorMsg.style.cssText = 'color: #e02229; font-size: 12px; margin-top: 4px; font-family: Gotham, sans-serif;';
                    errorMsg.textContent = 'An account with this email already exists. Please sign in instead.';
                    emailInput.parentElement.appendChild(errorMsg);
                    emailInput.style.borderBottomColor = '#e02229';
                    emailInput.setAttribute('data-email-exists', 'true');
                  } else {
                    emailInput.setAttribute('data-email-exists', 'false');
                  }
                } else {
                  console.warn('Storefront API token not configured. Email existence check disabled.');
                }
              });
            }
          };
          
          // Call it immediately and watch for dynamic additions
          setTimeout(addEmailValidation, 100);
          
          // Intercept form submission
          form.addEventListener('submit', async (e) => {
            // Hide any existing error
            errorContainer.style.setProperty('display', 'none', 'important');
            errorContainer.textContent = '';
            
            // Find email input
            const emailInput = shadow.querySelector('input[type="email"], input#email, input[name="email"], input[inputmode="email"]');
            
            if (emailInput && emailInput.value) {
              // Basic email format validation
              const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
              if (!emailRegex.test(emailInput.value)) {
                e.preventDefault();
                errorContainer.textContent = 'Please enter a valid email address';
                errorContainer.style.setProperty('display', 'block', 'important');
                errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                return;
              }
              
              // Check if we already validated and found the email exists
              if (emailInput.getAttribute('data-email-exists') === 'true') {
                e.preventDefault();
                errorContainer.textContent = 'An account with this email already exists. Please sign in instead.';
                errorContainer.style.setProperty('display', 'block', 'important');
                errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                return;
              }
              
              // If we haven't checked yet (user submitted without blur), check now
              if (STOREFRONT_API_TOKEN !== 'YOUR_STOREFRONT_API_TOKEN_HERE' && 
                  emailInput.getAttribute('data-email-exists') !== 'false') {
                e.preventDefault();
                
                // Show loading state
                const submitBtn = shadow.querySelector('button[type="submit"]');
                const originalText = submitBtn ? submitBtn.textContent : '';
                if (submitBtn) {
                  submitBtn.textContent = 'Checking email...';
                  submitBtn.disabled = true;
                }
                
                const customerExists = await checkCustomerExists(emailInput.value);
                
                if (customerExists) {
                  errorContainer.textContent = 'An account with this email already exists. Please sign in instead.';
                  errorContainer.style.setProperty('display', 'block', 'important');
                  errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                  
                  if (submitBtn) {
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                  }
                } else {
                  // Email doesn't exist, submit the form
                  if (submitBtn) {
                    submitBtn.textContent = originalText;
                    submitBtn.disabled = false;
                  }
                  form.requestSubmit();
                }
              }
            }
          });
          
          // Watch for network requests and responses
          // We need to intercept XMLHttpRequest as well as fetch
          const originalFetch = window.fetch;
          const originalXHROpen = XMLHttpRequest.prototype.open;
          const originalXHRSend = XMLHttpRequest.prototype.send;
          
          // Log all network requests to debug
          console.log('Setting up form error handling...');
          
          // Intercept fetch requests
          window.fetch = async function(...args) {
            console.log('Fetch request:', args[0]);
            const response = await originalFetch.apply(this, args);
            
            // Check if this is a form submission to the Shopify Forms API
            const url = args[0]?.toString ? args[0].toString() : args[0];
            if (url && url.includes('forms.shopifyapps.com/api/v2/form_submission')) {
              console.log('Form submission detected via fetch, status:', response.status);
              // Clone the response so we can read it without consuming it
              const responseClone = response.clone();
              
              if (response.status === 422 || response.status === 400) {
                try {
                  const errorData = await responseClone.json();
                  console.log('Form submission error data:', errorData);
                  console.log('Error fields:', Object.keys(errorData.errors || {}));
                  console.log('Error messages:', errorData.errors);
                  
                  // Display the error message
                  if (errorData.errors) {
                    const errorMessages = [];
                    
                    for (const [field, message] of Object.entries(errorData.errors)) {
                      // Check for email duplicate error
                      if (field.toLowerCase().includes('email')) {
                        if (message.toLowerCase().includes('taken') || 
                            message.toLowerCase().includes('already exists') || 
                            message.toLowerCase().includes('duplicate') ||
                            message.toLowerCase().includes('already in use') ||
                            message.toLowerCase().includes('already registered')) {
                          errorMessages.push('An account with this email address already exists. Please sign in instead of creating a new account.');
                        } else {
                          errorMessages.push(`Email ${message}`);
                        }
                      } else {
                        // Format field name to be more readable
                        const fieldName = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                        errorMessages.push(`${fieldName} ${message}`);
                      }
                    }
                    
                    errorContainer.textContent = errorMessages.join('. ');
                    errorContainer.style.setProperty('display', 'block', 'important');
                    
                    // Scroll to the error message
                    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                  } else if (errorData.message) {
                    // Check if the message is about duplicate email
                    if (errorData.message.includes('email') && (errorData.message.includes('taken') || errorData.message.includes('already exists') || errorData.message.includes('duplicate'))) {
                      errorContainer.textContent = 'An account with this email address already exists. Please sign in instead of creating a new account.';
                    } else {
                      errorContainer.textContent = errorData.message;
                    }
                    errorContainer.style.setProperty('display', 'block', 'important');
                    errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                  }
                } catch (err) {
                  console.error('Error parsing form submission response:', err);
                }
              } else if (response.ok) {
                // Hide error on successful submission
                errorContainer.style.setProperty('display', 'none', 'important');
              }
            }
            
            return response;
          };
          
          // Also intercept XMLHttpRequest
          XMLHttpRequest.prototype.open = function(method, url, ...args) {
            this._url = url;
            this._method = method;
            console.log('XHR request:', method, url);
            return originalXHROpen.apply(this, [method, url, ...args]);
          };
          
          XMLHttpRequest.prototype.send = function(...args) {
            const xhr = this;
            
            // Add event listener for response
            xhr.addEventListener('load', function() {
              if (xhr._url && xhr._url.includes('forms.shopifyapps.com/api/v2/form_submission')) {
                console.log('Form submission via XHR, status:', xhr.status);
                
                if (xhr.status === 422 || xhr.status === 400) {
                  try {
                    const errorData = JSON.parse(xhr.responseText);
                    console.log('XHR Form submission error:', errorData);
                    console.log('XHR Error fields:', Object.keys(errorData.errors || {}));
                    console.log('XHR Error messages:', errorData.errors);
                    
                    // Display the error message
                    if (errorData.errors) {
                      const errorMessages = [];
                      
                      for (const [field, message] of Object.entries(errorData.errors)) {
                        // Check for email duplicate error
                        if (field.toLowerCase().includes('email')) {
                          if (message.toLowerCase().includes('taken') || 
                              message.toLowerCase().includes('already exists') || 
                              message.toLowerCase().includes('duplicate') ||
                              message.toLowerCase().includes('already in use') ||
                              message.toLowerCase().includes('already registered')) {
                            errorMessages.push('An account with this email address already exists. Please sign in instead of creating a new account.');
                          } else {
                            errorMessages.push(`Email ${message}`);
                          }
                        } else {
                          // Format field name to be more readable
                          const fieldName = field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
                          errorMessages.push(`${fieldName} ${message}`);
                        }
                      }
                      
                      errorContainer.textContent = errorMessages.join('. ');
                      errorContainer.style.setProperty('display', 'block', 'important');
                      
                      // Scroll to the error message
                      errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    } else if (errorData.message) {
                      // Check if the message is about duplicate email
                      if (errorData.message.includes('email') && (errorData.message.includes('taken') || errorData.message.includes('already exists') || errorData.message.includes('duplicate'))) {
                        errorContainer.textContent = 'An account with this email address already exists. Please sign in instead of creating a new account.';
                      } else {
                        errorContainer.textContent = errorData.message;
                      }
                      errorContainer.style.setProperty('display', 'block', 'important');
                      errorContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    }
                  } catch (err) {
                    console.error('Error parsing XHR form submission response:', err);
                  }
                } else if (xhr.status >= 200 && xhr.status < 300) {
                  // Hide error on successful submission
                  errorContainer.style.setProperty('display', 'none', 'important');
                }
              }
            });
            
            return originalXHRSend.apply(this, args);
          };
          
          console.log('Form error handling added');
        }
      };
      
      // Add form error handling after a delay to ensure form is ready
      setTimeout(addFormErrorHandling, 500);
      
      // Also watch for error elements that might be added by the Forms app
      const errorObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === 1) { // Element node
              // Check if this is an error element
              const errorElements = node.classList?.contains('error') || 
                                  node.classList?.contains('field-error') ||
                                  node.classList?.contains('_error') ||
                                  node.textContent?.includes('invalid') ||
                                  node.textContent?.includes('error');
              
              if (errorElements) {
                console.log('Error element detected:', node);
              }
              
              // Also check children for error elements
              if (node.querySelectorAll) {
                const errors = node.querySelectorAll('[class*="error"], [class*="Error"], [data-error]');
                if (errors.length > 0) {
                  console.log('Found error elements:', errors);
                }
              }
            }
          });
        });
      });
      
      // Start observing the shadow DOM for error elements
      errorObserver.observe(shadow, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-error']
      });
      
      // Add a class to indicate the form is loaded and styled
      if (formContainer) {
        formContainer.classList.add('loaded');
      }
      
      console.log('B2B Forms app styles applied successfully');
      
      // Phone input container styling
      sheet.insertRule(`
        ._formPhoneInputContainer_1ym3p_6,
        [class*="_formPhoneInputContainer"] {
          display: flex !important;
          gap: 16px !important;
        }
      `);
      
      // Phone country selector styling
      sheet.insertRule(`
        .phone-country-selector,
        [class*="phone-country-selector"] {
          width: 30% !important;
          max-width: 100px !important;
          min-width: 80px !important;
        }
      `);
      
      // Form field container flex display
      sheet.insertRule(`
        ._formFieldContainer_1ydxd_5,
        [class*="_formFieldContainer"] {
          width: -webkit-fill-available !important;
          display: flex !important;
          margin-top: -5px !important;
        }
      `);
      
      // Aggressive dropdown height fix - check periodically
      let dropdownCheckInterval = setInterval(() => {
        // Look for dropdowns with any max-height inline style
        const dropdowns = shadow.querySelectorAll('div[style*="max-height"]');
        dropdowns.forEach(dropdown => {
          if (dropdown.classList.contains('_dropdownContainer_udw4q_63') || 
              dropdown.classList.contains('_showDownwards_udw4q_72') ||
              Array.from(dropdown.classList).some(cls => cls.includes('_dropdownContainer'))) {
            // Remove the inline max-height restriction
            dropdown.style.removeProperty('max-height');
            dropdown.style.setProperty('max-height', '350px', 'important');
            dropdown.style.setProperty('height', 'auto', 'important');
            dropdown.style.setProperty('min-height', '200px', 'important');
          }
        });
        
        // Also ensure option lists are scrollable
        const optionLists = shadow.querySelectorAll('._optionList_udw4q_86, [class*="_optionList"]');
        optionLists.forEach(list => {
          list.style.setProperty('max-height', '480px', 'important');
          list.style.setProperty('overflow-y', 'auto', 'important');
        });
      }, 100);
      
      // Stop checking after 30 seconds to avoid performance issues
      setTimeout(() => clearInterval(dropdownCheckInterval), 30000);
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});